import { Injectable } from '@angular/core';
import { Globals } from './globals';
import { HttpClient } from '@angular/common/http';

@Injectable({ providedIn: 'root' })
export class DataService {

    constructor(private http: HttpClient, private globals: Globals) {
    }

    public getFieldTerms(indexPattern: string, fieldKey: string, searchFilter: string = '', externalAccessToken = undefined) {
        let params: any = {
            index_pattern: indexPattern,
            field_key: fieldKey,
            search_filter: (searchFilter)? searchFilter: ''
        };
        if (externalAccessToken) {
            params['external_access_token'] = externalAccessToken;
            return this.http.get<string[]>(`${this.globals.api_base_url}/external/data/field-terms`, { params: params});
        } else {
            return this.http.get<string[]>(`${this.globals.api_base_url}/data/field-terms`, { params: params});
        }
    }

    public rawSearch(indexPattern: string, requestBody: any = {}, externalAccessToken = null) {
        const requestStr: string = JSON.stringify(requestBody);
        let params: any = {
            index_pattern: indexPattern,
            body: requestStr
        };
        if (externalAccessToken) {
            params['external_access_token'] = externalAccessToken;
            return this.http.post<any>(`${this.globals.api_base_url}/external/data/raw-search`, params);
        } else {
            return this.http.post<any>(`${this.globals.api_base_url}/data/raw-search`, params);
        }
    }

    public sqlQueryResults(query: string, format: string = 'json', externalAccessToken = null) {
        let params: any = {
            query: query,
            format: format
        };
        if (externalAccessToken) {
            params['external_access_token'] = externalAccessToken;
            return this.http.post<any>(`${this.globals.api_base_url}/external/data/sql-query`, params);
        } else {
            return this.http.post<any>(`${this.globals.api_base_url}/data/sql-query`, params);
        }
    }
}